import tocbot from "tocbot";

export function createTableOfContents() {
  tocbot.init({
    // Where to render the table of contents.
    tocSelector: "#toc",
    // Where to grab the headings to build the table of contents.
    contentSelector: "#content",
    // Which headings to grab inside of the contentSelector element.
    headingSelector: "h2, h3, h4",
    // For headings inside relative or absolute positioned containers within content.
    hasInnerContainers: true,
    ignoreSelector: "[data-toc-ignore]",
    scrollSmooth: false,
    collapseDepth: 2,
  });
}

export function filterContentsInit() {
  const filterField = document.querySelector("#filter-field");

  filterField.addEventListener("input", filterContents);
}

function filterContents(event) {
  if (event.target.value.length === 0) {
    createTableOfContents();
    return;
  }

  const $items = document.querySelectorAll("#toc>ol>li");
  const $firstOl = document.querySelector("#toc>ol");
  const frag = document.createDocumentFragment();
  $items.forEach(function (li, i) {
    if (
      li.textContent.toLowerCase().includes(event.target.value.toLowerCase())
    ) {
      frag.appendChild($items[i]);
    }
  });

  $firstOl.innerHTML = "";
  $firstOl.appendChild(frag);
}
